export const firebaseStageCredentials = {
  apiKey: 'AIzaSyCU37doYaWlV1M2187ooyGM3LXQSUSVS04',
  authDomain: 'orlikfy-infra-stage.firebaseapp.com',
  projectId: 'orlikfy-infra-stage',
  storageBucket: 'orlikfy-infra-stage.appspot.com',
  messagingSenderId: '549724039355',
  appId: '1:549724039355:web:f81825d7b401a42346a19e'
};
